<template>
  <el-form ref="generateForm"
           label-suffix=":"
           :size="data.config.size"
           :model="models" :label-position="data.config.labelPosition" :label-width="`${data.config.labelWidth}px`">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="基本信息" name="1">
        <div class="el-drawer_body">
          <template v-for="item in gridArray">
            <template v-if="item.type == 'grid'">
            <el-row :key="item.key"
                    :gutter="item.options.gutter ? item.options.gutter : 0"
                    :justify="item.options.justify"
                    :align="item.options.align">
              <el-col v-for="(col, colIndex) in item.columns" :key="colIndex" :span="col.span">
                <template v-for="citem in col.list">
                  <el-form-item v-if="citem.type=='blank'" :label="citem.name" :prop="citem.model" :key="citem.key">
                    <slot :name="citem.model" :model="models"></slot>
                  </el-form-item>
                  <ShowViewFormItem v-else
                    :key="citem.key"
                    :models.sync="models"
                    :remote="remote"
                    :islable="true"
                    :funModel="funModel"
                    :formData="citem">
                  </ShowViewFormItem>
                </template>
              </el-col>
            </el-row>
            </template>
            <template v-else>
              <ShowViewFormItem v-if="item && item.key" :key="item.key"
                    :models.sync="models"
                    :remote="remote"
                    :islable="true"
                    :funModel="funModel"
                    :formData="item" ></ShowViewFormItem>
            </template>
          </template>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="item.name" :name="(index+2).toString()" :key="item.key" v-for="(item,index) in tableArray">
        <el-table :key="item.key"
                  :data="models[item.model]"
                  class="subtable"
                  border fit>
          <el-table-column type="index" fixed="left" width="50"></el-table-column>
          <template v-for="(tableItem) in item.list">
            <el-table-column :key="tableItem.key" :label="tableItem.name" :width="tableItem.options.tableWidth">
              <template slot-scope="scope">
                <ShowViewFormItem :key="tableItem.key"
                                  :models.sync="scope.row"
                                  :formData="tableItem"
                                  :itemkey="scope.$index"
                                  :tablemodel="item.model"
                                  :remote="tableItem.remote"
                                  :funModel="funModel"
                                  :islable="false">
                </ShowViewFormItem>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </el-form>
</template>

<script>
import ShowViewFormItem from './ShowViewFormItem';
export default {
  name: 'fm-generate-form',
  components: {
    ShowViewFormItem
  },
  props: ['data', 'remote', 'value', 'insite', 'isDisabled', 'funModel'],
  data() {
    return {
      models: {},
      activeName: '1',
      tableArray: [],
      gridArray: []
    };
  },
  created() {
    this.generateModle(this.data.list, false);
    this.models = { ...this.models, ...this.value };
  },
  mounted() {
  },
  methods: {
    reseltActiveName() {
      this.activeName = '1';
    },
    // 初始化models赋值和获取校验规则
    generateModle(arr, type) { // 数据，类型（是否为栅格布局传入的递归）
      arr.length > 0 && arr.forEach(arrItem => {
        if (arrItem.type === 'grid') { // 如果是栅格布局则进入递归
          this.gridArray.push(arrItem);
          arrItem.columns.forEach(item => {
            this.generateModle(item.list, true);
          });
        } else if (arrItem.type === 'table') {
          this.tableArray.push(arrItem);// 重新打开页面时 将重置其中的数据
          this.$set(this.models, arrItem.model, arrItem.options.defaultValue);// 这样添加数据才能监听到
          // 获取子表单校验规则
        } else {
          if (arrItem.type === 'blank') {
            this.$set(this.models, arrItem.model, arrItem.options.defaultType === 'String' ? '' : (arrItem.options.defaultType === 'Object' ? {} : []));
          } else {
            if (!type) { // 不是栅格布局传入的，则在页面显示，避免与栅格布局中的重复
              this.gridArray.push(arrItem);
            }
            this.models[arrItem.model] = arrItem.options.defaultValue;
          }
          // 获取主表校验规则
        }
      });
    }
  },
  watch: { // 数据监听
    data: { // 外部传入的表单结构
      deep: true, // 深度监听，如果监听的是对象则一直循环监听，每一个字段改变都能监听到
      handler(val) {
        this.gridArray = [];
        this.tableArray = [];
        this.generateModle(val.list, false);
        this.models = { ...this.models, ...this.value };
      }
    },
    value: {
      deep: true,
      handler(val) { // 重新给models覆盖数据
        this.models = { ...this.models, ...val };
      }
    }
    // models: {
    //   deep: true,
    //   handler(val) { // 监听models，用于当子表单中的组件需要主表的数据时，及时更新查询所用数据
    //     const tempArray = this.data.list.filter(item => {
    //       return item.type === 'table'
    //     })// 筛选子表数据
    //     tempArray.length > 0 && tempArray.forEach(item => { // 遍历子表数据
    //       const itemKey = item.list.map(m => { return m.model })// 获取子表单每一行对象的所有属性
    //       const modelsKey = Object.keys(val)// 获取当前主表中的所有字段属性
    //       item.list.filter(listItem => {
    //         return listItem.type === 'autoNew'
    //       }).forEach(listItem => { // 筛选选择关联组件并遍历
    //         listItem.options.otherquery.forEach(m => { // 遍历查询条件
    //           this.models[item.model].forEach(tempItem => {
    //             if (!itemKey.includes(m.modelkey) && modelsKey.includes(m.modelkey)) { // 若不存在于子表单则去主表单里找到并添加进来，若在子表单中就有则无需处理
    //               this.$set(tempItem, m.modelkey, val[m.modelkey])
    //             }
    //           })
    //         })
    //       })
    //     })
    //   }
    // }
  }
};
</script>

<style lang="scss">

  .created-form-content {
    position: relative;
    .form-model

  {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
  }

  }

  .dialog-mini .subtable .el-form-item {
    margin-bottom: 0px;
  }

    .dialog-mini .subtable .el-form-item.is-error.is-required.el-form-item--small {
      margin-bottom: 0px;
    }
</style>

